
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syllabus/gate",
      function () {
        return require("private-next-pages/syllabus/gate.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syllabus/gate"])
      });
    }
  